import { useCallback } from "react";
import { useLocalization } from "@fluent/react";
import { useFeature } from "byzantine/src/dbbl/businessLogic/modules/features";
import { canUseAchPassthrough } from "byzantine/src/dbbl/businessLogic/modules/features/paymentActivity";
import { useUserFeatures } from "../../contexts/UserFeaturesContext";
import { FilterChips, FilterType, FILTER_CONFIG } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const FileImportMethodFilter = ({
  isActive,
  filters,
  handleSetFilter,
  handleSetActive,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const { featureEnabled } = useFeature();
  const features = useUserFeatures();
  const label = l10n.getString(
    FILTER_CONFIG[FilterChips.FILE_IMPORT_METHOD].labelKey
  );
  const optionLabels = {
    "label-method-ach": l10n.getString("label-method-ach"),
    "label-method-wire": l10n.getString("label-method-wire"),
    "file-upload-type-passthrough-title": l10n.getString(
      "file-upload-type-passthrough-title"
    ),
  };

  const filterByFeatureEnabled = useCallback(
    (option: { key: string; featureFlags?: readonly string[] }) => {
      if (option.key === "ach_passthrough") {
        return canUseAchPassthrough(features);
      }
      return (
        !option.featureFlags || featureEnabled({ and: option.featureFlags })
      );
    },
    [featureEnabled, features]
  );

  const filterOptions = FILTER_CONFIG[FilterChips.FILE_IMPORT_METHOD].options
    .filter(filterByFeatureEnabled)
    .map((option) => ({
      ...option,
      label: optionLabels[option.labelKey],
    }));

  return (
    <MultiSelectFilter
      isActive={isActive}
      filters={filters}
      handleSetFilter={handleSetFilter}
      handleSetActive={handleSetActive}
      handleToggleFilter={handleToggleFilter}
      filterName={FilterChips.FILE_IMPORT_METHOD}
      filterOptions={filterOptions}
      label={label}
    />
  );
};

export default FileImportMethodFilter;
